import { createContext } from 'react';
import { IDictionary } from '@belong/types';

export type DictionaryContextType = IDictionary;

export const DEFAULT_DICTIONARY: DictionaryContextType = Object.freeze({});

export const DictionaryContext = createContext<DictionaryContextType>(DEFAULT_DICTIONARY);
